import React from 'react';
import { FiCheck, FiX } from 'react-icons/fi';
import './PasswordRequirements.css';

const PasswordRequirements = ({ password }) => {
  const requirements = [
    { label: 'At least 8 characters', test: (p) => p.length >= 8 },
    { label: 'One uppercase letter', test: (p) => /[A-Z]/.test(p) },
    { label: 'One lowercase letter', test: (p) => /[a-z]/.test(p) },
    { label: 'One number', test: (p) => /[0-9]/.test(p) },
    { label: 'One special character', test: (p) => /[^a-zA-Z0-9]/.test(p) },
  ];

  return (
    <div className="password-requirements">
      <p className="password-requirements-title">Password must have:</p>
      <ul>
        {requirements.map((req, i) => {
          const passed = req.test(password || '');
          return (
            <li key={i} className={passed ? 'passed' : 'failed'}>
              {passed ? <FiCheck /> : <FiX />}
              {req.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordRequirements;